import { Money } from '@percent/utility'
import { IconProps } from '@percent/lemonade'

export enum CardType {
  FUNDRAISER = 'fundraiser',
  OPPORTUNITY = 'opportunity',
  SUGGESTED_FUNDRAISER = 'suggested-fundraiser',
}

export type BasicFeaturedCardProps = {
  title: string
  badgeText?: string
  imgSrc?: string
  actionButton?: () => void
  cardButtonInfo?: React.ReactNode
  organisationBadge: string | null
  organisationBadgeTooltip: string | null
}

export type FeaturedFundraiserCardProps = BasicFeaturedCardProps & {
  type: CardType.FUNDRAISER
  organisationName: string
  organisationLogo: string
  total: Money
  goal: Money
  locale: string
  ofText?: string
  totalRaisedText?: string
  beTheFirstToDonateText?: string
}

export type FeaturedOpportunityCardProps = BasicFeaturedCardProps & {
  type: CardType.OPPORTUNITY
  startDate?: string
  organisationName?: string
  organisationLogo?: string
  locationIcon?: IconProps['name']
  locationText?: string
}

export type SuggestedFundraiserCardProps = BasicFeaturedCardProps & {
  type: CardType.SUGGESTED_FUNDRAISER
  organisationName: string
  organisationLogo: string
  total: Money
  goal: Money
  locale: string
  ofText?: string
  totalRaisedText?: string
  beTheFirstToDonateText?: string
}

export type FeaturedCardProps =
  | FeaturedFundraiserCardProps
  | FeaturedOpportunityCardProps
  | SuggestedFundraiserCardProps

export type TitleContentProps = {
  title: string
  isSuggestedFundraiser: boolean
  isTitleOverflowing: boolean
}

export type FeaturedFundraiserDetailsProps =
  | FeaturedFundraiserCardProps
  | SuggestedFundraiserCardProps
